import { StrictMode, lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import { resolveSurface } from './main-dispatch';

const surface = resolveSurface(window.location.hostname, window.location.search);

const SurfaceRoot = lazy(() =>
  surface === 'app'
    ? import('./app/AppRoot').then((m) => ({ default: m.default }))
    : import('./marketing/MarketingRoot').then((m) => ({ default: m.default }))
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={null}>
      <SurfaceRoot />
    </Suspense>
  </StrictMode>
);
